import React from 'react';
import styles from './form.module.scss';
import { Invalid } from './InputComponent';

interface InputProps {
    id: string;
    label: string;
    form: string;
    value: string;
    setValue: Function;
    invalid: Invalid;
    toggleInvalid: Function;
    borderColor: string;
    toggleBorderColor: Function;
}

const TextAreaComponent = ({
    id,
    label,
    form,
    value,
    setValue,
    invalid,
    toggleInvalid,
    borderColor,
    toggleBorderColor,
}: InputProps) => {
    return (
        <div className={styles.textAreaContainer}>
            <label htmlFor={id} className={styles.textAreaLabel}>
                {label}
            </label>
            <textarea
                id={id}
                form={form}
                className={styles.textAreaInput}
                style={{
                    backgroundColor: '##FFFFFF66',
                    borderColor,
                }}
                value={value}
                cols={6}
                rows={4}
                aria-label={label}
                onChange={(event) => {
                    setValue(event.target.value);
                    if (event.target.value.length > 0) {
                        toggleBorderColor('#c3c3c5');
                        toggleInvalid('none');
                    }
                }}
            />
            <span className={styles.invalid} style={{ display: invalid }}>
                Please fill out this field
            </span>
        </div>
    );
};

export default TextAreaComponent;
